import apiClient from '@/services/axios'

export async function patch(bookingId, userId) {

  var response = await apiClient.patch(process.env.VUE_APP_MARCOM_API_BASE_URL + `/admin/bookings/${bookingId}/assign-host/${userId}`);

  if (response) {
    console.log(response)
    return response.data;
  }

  throw new Error('Unable to assign host.');
}
